import { useState } from 'react';
import './Portfolio.css';

const img = (name) => `${process.env.PUBLIC_URL}/images/optimized/${name}`;

const Portfolio = () => {
  const [activeCategory, setActiveCategory] = useState('Todos');

  const categories = ['Todos', 'Corporativo', 'Show', 'Shopping', 'Igreja', 'Publicidade'];

  const projects = [
    {
      image: img('convencao-multi-tela-led-800.webp'),
      category: 'Corporativo',
      title: 'Convenção Empresarial',
      description: 'Painel LED P2.5 de 6x3m para convenção com mais de 2.000 participantes.',
      alt: 'Convenção corporativa com múltiplos painéis de LED exibindo apresentação no palco'
    },
    {
      image: img('show-por-do-sol-led-800.webp'),
      category: 'Show',
      title: 'Show ao Ar Livre',
      description: 'Telões laterais LED P4.8 de 8x4m para show ao ar livre com 10.000 pessoas.',
      alt: 'Show ao ar livre durante pôr do sol com telões de LED laterais iluminando o palco'
    },
    {
      image: img('shopping-totem-led-vertical-800.webp'),
      category: 'Shopping',
      title: 'Shopping Center Premium',
      description: 'Totem LED vertical P2.5 de 4m de altura para área nobre de shopping center.',
      alt: 'Totem de LED vertical em shopping center de luxo com iluminação elegante'
    },
    {
      image: img('igreja-conferencia-led-800.webp'),
      category: 'Igreja',
      title: 'Conferência de Adoração',
      description: 'Telão LED P2.9 de 8x4m para conferência religiosa com 3.000 participantes.',
      alt: 'Conferência de adoração com grande telão de LED no palco da igreja'
    },
    {
      image: img('publicidade-outdoor-led-800.webp'),
      category: 'Publicidade',
      title: 'Outdoor Digital',
      description: 'Painel LED P10 outdoor de 6x3m para publicidade em fachada de edifício comercial.',
      alt: 'Painel de LED publicitário em fachada de edifício com anúncio luminoso'
    },
    {
      image: img('lobby-corporativo-totem-led-800.webp'),
      category: 'Corporativo',
      title: 'Lobby Corporativo',
      description: 'Totem LED P1.9 de recepção para lobby de empresa multinacional.',
      alt: 'Totem de LED de boas-vindas no lobby corporativo moderno'
    },
    {
      image: img('shopping-painel-led-corredor-800.webp'),
      category: 'Shopping',
      title: 'Comunicação Visual em Shopping',
      description: 'Painel LED P2.5 em corredor principal para campanhas de alto impacto visual.',
      alt: 'Painel de LED em corredor de shopping center com pessoas caminhando'
    },
    {
      image: img('festival-led-paineis-laterais-800.webp'),
      category: 'Show',
      title: 'Festival de Música',
      description: 'Telão LED P3.9 outdoor de 12x6m para festival com 15.000 pessoas.',
      alt: 'Festival de música com painéis de LED laterais artísticos iluminando o palco noturno'
    }
  ];

  const filteredProjects = activeCategory === 'Todos'
    ? projects
    : projects.filter(p => p.category === activeCategory);

  return (
    <section id="portfolio" className="portfolio">
      <div className="section-container">
        <div className="section-header" data-aos="fade-up">
          <span className="section-label">Portfólio</span>
          <h2>Projetos que já <span>transformamos</span></h2>
          <p>Cada projeto é único. Veja como nossos painéis de LED elevaram a experiência em diferentes segmentos.</p>
        </div>

        <div className="portfolio__filters" data-aos="fade-up">
          {categories.map((cat) => (
            <button
              key={cat}
              className={`portfolio__filter-btn ${activeCategory === cat ? 'portfolio__filter-btn--active' : ''}`}
              onClick={() => setActiveCategory(cat)}
            >
              {cat}
            </button>
          ))}
        </div>

        <div className="portfolio__grid">
          {filteredProjects.map((project, index) => (
            <div key={`${project.title}-${index}`} className="portfolio__card" data-aos="fade-up" data-aos-delay={index * 80}>
              <div className="portfolio__image">
                <img src={project.image} alt={project.alt} loading="lazy" width="800" height="500" />
                <div className="portfolio__image-overlay">
                  <span className="portfolio__category">{project.category}</span>
                </div>
              </div>
              <div className="portfolio__info">
                <h3>{project.title}</h3>
                <p>{project.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Portfolio;
